module.exports = __webpack_public_path__ + "img/obs_water_flood_up.c1cc70c5.svg";